/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heating_Network_Type_Sanitary_Hot_WaterInputs */



/**
* | output |
* | --- |
* | "DHW" |
*
* @param {Heating_Network_Type_Sanitary_Hot_WaterInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const heating_network_type_sanitary_hot_water = /** @type {((inputs?: Heating_Network_Type_Sanitary_Hot_WaterInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heating_Network_Type_Sanitary_Hot_WaterInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("DHW")
	return /** @type {LocalizedString} */ ("ECS")
});